/* Find your piece: 4-step guided selection scored against real product data. */
(() => {
  const root = document.querySelector('[data-lp-quiz]');
  if (!root) return;
  const products = JSON.parse(root.querySelector('[data-lp-quiz-data]').textContent || '[]');
  const form = root.querySelector('form');
  const steps = [...root.querySelectorAll('.lp-quiz__step')];
  const next = root.querySelector('[data-lp-quiz-next]');
  const back = root.querySelector('[data-lp-quiz-back]');
  const stepNo = root.querySelector('[data-lp-quiz-step]');
  const results = root.querySelector('[data-lp-quiz-results]');
  const grid = root.querySelector('[data-lp-quiz-grid]');
  const ROOM_LABEL = { Living: 'living room', Dining: 'dining room', Bedroom: 'bedroom', Entryway: 'entryway' };
  const KIND = {
    vase: (p) => /vase/i.test(p.type),
    sculpture: (p) => /sculpture|figurine|ornament/i.test(p.type),
    tabletop: (p) => /candle|bowl|diffuser|frame|tissue/i.test(p.type),
    gift: (p) => p.gift === true,
    statement: (p) => (p.style || []).includes('Statement'),
  };
  let i = 0;

  const answer = (name) => form.querySelector(`[name="${name}"]:checked`)?.value;
  const show = (n) => {
    i = n;
    steps.forEach((s, k) => { s.hidden = k !== i; });
    stepNo.textContent = String(i + 1);
    back.hidden = i === 0;
    next.textContent = i === steps.length - 1 ? 'See my pieces' : 'Next';
    next.disabled = !steps[i].querySelector('input:checked');
    steps[i].querySelector('legend').focus({ preventScroll: true });
  };

  const card = (p) => {
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.className = 'lp-quiz__card';
    a.href = p.url;
    const media = document.createElement('div');
    media.className = 'lp-media';
    if (p.img) { const img = document.createElement('img'); img.src = p.img; img.alt = p.alt; img.loading = 'lazy'; img.width = 600; img.height = 750; media.append(img); }
    const meta = document.createElement('p'); meta.className = 'lp-eyebrow'; meta.textContent = p.material || p.type;
    const title = document.createElement('p'); title.className = 'lp-card__title'; title.textContent = p.title;
    const price = document.createElement('p'); price.className = 'lp-price'; price.textContent = p.priceText;
    a.append(media, meta, title, price);
    li.append(a);
    return li;
  };

  const run = () => {
    const room = answer('room'); const style = answer('style'); const kind = answer('kind');
    const [lo, hi] = (answer('budget') || '0-999999').split('-').map(Number);
    const scored = products.map((p) => {
      let s = 0;
      if ((p.room || []).includes(room)) s += 3;
      if ((p.style || []).includes(style)) s += 2;
      if (KIND[kind]?.(p)) s += 3;
      const inBudget = p.price >= lo && p.price < hi;
      if (inBudget) s += 4;
      return { p, s, inBudget };
    }).sort((a, b) => b.s - a.s || a.p.price - b.p.price);
    const picks = scored.filter((x) => x.s >= 4).slice(0, 6);
    const list = picks.length >= 3 ? picks : scored.slice(0, 6);
    grid.replaceChildren(...list.map((x) => card(x.p)));
    const matchedBudget = list.filter((x) => x.inBudget).length;
    root.querySelector('[data-lp-quiz-summary]').textContent = matchedBudget === list.length
      ? `${list.length} pieces that suit a ${ROOM_LABEL[room] || 'room'} and your budget.`
      : `${matchedBudget} of these fit your budget; the rest are the closest matches for your ${ROOM_LABEL[room] || 'room'} and style.`;
    form.hidden = true;
    results.hidden = false;
    results.querySelector('[data-lp-quiz-results-title]').focus({ preventScroll: false });
    window.lpTrack?.('quiz_complete', { room, style, kind, budget: `${lo}-${hi}`, results: list.length });
  };

  form.addEventListener('change', () => { next.disabled = !steps[i].querySelector('input:checked'); });
  next.addEventListener('click', () => (i < steps.length - 1 ? show(i + 1) : run()));
  back.addEventListener('click', () => show(i - 1));
  root.querySelector('[data-lp-quiz-restart]').addEventListener('click', () => { form.reset(); form.hidden = false; results.hidden = true; show(0); });
})();
